import { createApi } from '@reduxjs/toolkit/query/react';

import { generateBaseQuseryWithReAuth } from '@/store/baseQueryReauth';
import { ResponseError } from '@/types/Error';
import { InterstitialModalPayload, InterstitialModalResponse } from '@/types/InterstitialModal';
import { SuccessResponse } from '@/types/Success';

const contentTypes = {
  applicationJson: 'application/json',
};

export const interstitialApi = createApi({
  reducerPath: 'interstitialApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: '' }),
  tagTypes: [],
  endpoints: builder => ({
    createCustomerInterstitial: builder.mutation<SuccessResponse<InterstitialModalResponse>, InterstitialModalPayload>({
      query: data => ({
        url: `/marketing/CreateCustomerInterstitial`,
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': contentTypes.applicationJson,
        },
      }),
      transformResponse: (response: SuccessResponse<InterstitialModalResponse>, meta, arg) => response,
      transformErrorResponse: response => response as ResponseError,
    }),
  }),
});

export const { useCreateCustomerInterstitialMutation } = interstitialApi;
